import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import App from '@app';
import { Body, PageHeader, AddButton, Collapse, CollapsePanel, View, Icon } from '@components';
import { getVersoes, getVersaoConectores, setVersaoSelecionadaTela } from '@ducks/conectoresVersoes';
import TableVersoes from './TableVersoes';
import ItemVersaoConectoresLayout from './ItemVersaoConectores';
import styled from 'styled-components';

const GroupViews = styled(View)`
  flex-direction: row;
`;

const ViewTableVersoes = styled(View)`
  flex: 1;
  padding: 0px;
  margin-left: 15px;
`;

const ListVersaoConectores = styled(Collapse)`
  flex: 1;
  padding: 0px;
  margin-left: 15px;
  background-color: #ffffff;
`;

const PanelVersaoConectores = styled(CollapsePanel)`
  display: flex;
  font-weight: bold;
  flex-direction: column;
  width: 100%;
  border-bottom: 1px solid #d9d9d9;
`;

const DownloadView = styled(View)`
  justify-content: center;
  align-items: center;
  font-size: 60px;
  height: 100%;
`;

export default function Versoes() {
  const dispatch = useDispatch();
  const history = useHistory();

  const versaoConectores = useSelector(({ conectoresVersoes }) => conectoresVersoes.get('versaoConectores'));
  const loadingVersaoConectores = useSelector(({ conectoresVersoes }) => conectoresVersoes.get('loadingVersaoConectores'));
  const versoes = useSelector(({ conectoresVersoes }) => conectoresVersoes.get('versoes'));
  const successVersoes = useSelector(({ conectoresVersoes }) => conectoresVersoes.get('successVersoes'));
  const downloadingVersao = useSelector(({ conectoresVersoes }) => conectoresVersoes.get('downloadingVersao'));
  const versaoDownload = useSelector(({ conectoresVersoes }) => conectoresVersoes.get('versaoDownload'));

  const handleSearch = () => {
    return dispatch(getVersoes());
  };

  useEffect(() => {
    handleSearch();
  }, []);

  useEffect(() => {
    if (successVersoes && versoes) {
      const { nrBuild } = versoes.toArray()[0];
      dispatch(getVersaoConectores(nrBuild));
      dispatch(setVersaoSelecionadaTela(nrBuild));
    }
  }, [successVersoes]);

  const renderPanelVersaoConectores = () => {
    return versaoConectores.map((versaoConector) => (
      <PanelVersaoConectores header={versaoConector.nmCliente} key={versaoConector.cdCliente}>
        <ItemVersaoConectoresLayout item={versaoConector} />
      </PanelVersaoConectores>
    ));
  };

  return (
    <App>
      <Body>
        <PageHeader
          title={!downloadingVersao && 'Versões'}
          extra={[
            !downloadingVersao && (
              <AddButton
                key="1"
                type="primary"
                tooltipTitle="Adicionar Versão"
                style={{ marginBottom: 10 + 'px', borderRadius: 5 + 'px' }}
                onClick={() => history.push('/conectores/versao/-1')}
              />
            ),
          ]}
        >
          {downloadingVersao ? (
            <DownloadView>
              <View>Realizando download da versão {versaoDownload}</View>
              <Icon.SyncOutlined spin />
            </DownloadView>
          ) : (
            <GroupViews>
              <ViewTableVersoes>
                <TableVersoes />
              </ViewTableVersoes>
              <ListVersaoConectores accordion loading={loadingVersaoConectores}>
                {renderPanelVersaoConectores()}
              </ListVersaoConectores>
            </GroupViews>
          )}
        </PageHeader>
      </Body>
    </App>
  );
}
